import { render, staticRenderFns } from "./EventHotels.vue?vue&type=template&id=3a8c6bb8&"
import script from "./EventHotels.vue?vue&type=script&lang=js&"
export * from "./EventHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports